import type { UnknownOutputParams } from 'expo-router'
import type { PropsWithChildren, ReactNode } from 'react'

import { AlertBanner } from '@/src/features/alerts/ui/components/AlertBanner'
import { DonationProvider } from '@/src/features/donation/context/DonationContext'
import { usePageType } from '@/src/general/hooks/usePageType'

type TBannersProviderProps = PropsWithChildren<{
  searchParams: UnknownOutputParams
}>

export const BannersProvider = ({ children, searchParams }: TBannersProviderProps): ReactNode => {
  const { showBanners } = usePageType()

  return (
    <DonationProvider searchParams={searchParams} disabled={!showBanners}>
      {showBanners && <AlertBanner />}
      {children}
    </DonationProvider>
  )
}
